var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip-box"},[_vm._t("body"),_c('div',{staticClass:"message"},[_vm._t("message")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }